<section class="c2">
  <div class="container c2">
    <div class="title c2">
      <small>F.A.Q.</small>
      <h2>{{gameTitle[game]}} {{service}} FAQs</h2>
    </div>
    <div class="faq c2">
      <div *ngFor="let faq of serviceFaqs; let i = index" class="card faq-box c2">
        <div class="ico c2 mini-flex">
          <i class="uil uil-lightbulb-alt" [style.color]="faqColors[i]">
            <img class="bulb" src="https://cdn.ggboost.com/images/icons/bulb.png" alt="faq bulb icon">
          </i>
        </div>
        <div class="flex">
          <h3>{{faq.question}}</h3>
          <p>{{faq.answer}}</p>
        </div>
      </div>
    </div>
  </div>
</section>
